import $ from 'jquery';
// import Flickity from 'flickity';

const selectors = {
  slide: '[data-slide]',
  speed: 'data-slider-speed',
  slideAttribute: 'data-slide',
  dataSlideIndex: 'data-slide-index',
};

class AnnouncementSlider {
  constructor(container, el) {
    this.container = container;
    this.slideshow = el;
    const speedElement = this.slideshow.getAttribute(selectors.speed);
    this.speed = speedElement ? parseInt(speedElement) : false;

    if (!this.slideshow) return;

    this.flkty = null;

    this.init();
  }

  init() {
    $(this.slideshow)
      .slick({
        "arrows": false,
        "autoplay": true,
        "autoplaySpeed": this.speed
      });

    /*
    const sliderOptions = {
      initialIndex: 0,
      autoPlay: this.speed,
      contain: true,
      pageDots: false,
      adaptiveHeight: false,
      wrapAround: true,
      groupCells: false,
      cellAlign: 'left',
      freeScroll: false,
      prevNextButtons: true,
      draggable: true,
      on: {
        ready: () => {
          setTimeout(() => {
            this.slideshow.dispatchEvent(
              new CustomEvent('theme:announcement:loaded', {
                bubbles: true,
                detail: {
                  slider: this,
                },
              })
            );
          }, 10);
        },
      },
    };

    this.flkty = new Flickity(this.slideshow, sliderOptions);
    console.log(sliderOptions);
    */
  }

  onUnload() {
    if (this.slideshow) {
      $(this.slideshow).slick('unslick');
    }
    /*
    if (this.slideshow && this.flkty) {
      this.flkty.options.watchCSS = false;
      this.flkty.destroy();
    }
    */
  }

  onBlockSelect(evt) {
    // if (!this.slideshow) return;
    // const slideIndex = parseInt(slide.getAttribute(selectors.dataSlideIndex));
    // console.log({
    //   "slideIndex": slideIndex
    // })

    // $(this.slideshow)
    //   .slick('goTo', slideIndex)
    //   .slick('slickPause');

    /*
    // Ignore the cloned version
    const slide = this.slideshow.querySelector(`[${selectors.slideAttribute}="${evt.detail.blockId}"]`);

    if (!slide) return;
    const slideIndex = parseInt(slide.getAttribute(selectors.dataSlideIndex));

    // Go to selected slide, pause autoplay
    this.flkty.selectCell(slideIndex);
    this.flkty.stopPlayer();
    */
  }

  onBlockDeselect() {
    /*
    this.flkty.playPlayer();
    */
  }
}

export {AnnouncementSlider};
